// Auto-discovers every `templates/<key>/index.js` (except the shared `widgets/`
// folder) via webpack's require.context, so adding a new template folder is
// enough to make it selectable — no manual registration needed here.
const context = require.context('./', true, /^\.\/(?!widgets)[^/]+\/index\.js$/);

const templates = context.keys().map((key) => context(key).default);

// Templates with `is_deploy: false` are excluded from selection at runtime (the prebuild
// step also strips their folders from the bundle entirely — see scripts/filterDeployTemplates.js).
const deployableTemplates = templates.filter((t) => t.manifest.is_deploy !== false);

export function getTemplates() {
  return deployableTemplates.map((t) => t.manifest);
}

export function getTemplate(key) {
  return deployableTemplates.find((t) => t.manifest.key === key) || null;
}

// Which template is rendered when no runtime selection is available yet
// (first paint before brand config loads, or if the configured key is unknown).
export const ACTIVE_TEMPLATE_KEY = process.env.REACT_APP_ACTIVE_TEMPLATE || 'classic';

// `activeKey` is the runtime `active_template_key` selected from the dashboard's
// Platform Settings → Template tab (via BrandConfigContext). Falls back to the
// build-time env var, then 'classic', if unset/unknown.
export function getActiveTemplate(activeKey) {
  return getTemplate(activeKey) || getTemplate(ACTIVE_TEMPLATE_KEY) || getTemplate('classic');
}
